import { Mapper } from "planning-portal-library/src/lib/core/base";
import { AttachScheduler } from "planning-portal-library/src/lib/core/domain";
import { SchedulerWebEntity } from "./scheduler-web-entity";

export class SchedulerWebRepository extends Mapper<SchedulerWebEntity, AttachScheduler> {

  mapFrom(param: SchedulerWebEntity): AttachScheduler {
    return {
      planId: param.planId,
      fromDate: param.fromDate,
      toDate: param.toDate,
      bufferHours: param.bufferHours,
      timeZone:param.timeZone,
      offSet:param.offSet,
      executionTime: param.executionTime,
      planWeekDays: param.planWeekDays
    };
  }

  mapTo(param: AttachScheduler): SchedulerWebEntity {
    return {
      planId: param.planId,
      fromDate: param.fromDate,
      toDate: param.toDate,
      bufferHours: param.bufferHours,
      timeZone:param.timeZone,
      offSet:param.offSet,
      executionTime: param.executionTime,
      planWeekDays: param.planWeekDays
    };
  }
}
